import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { FormControlLabel, Checkbox } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControlLabel: {
      marginBottom: theme.spacing(3)
    },
    checkbox: {
      '&.Mui-checked': {
        color: theme.palette.pomagranatered.main
      }
    }
  })
);

interface IProps {
  onChange: React.EventHandler<React.ChangeEvent<HTMLInputElement>>;
  aggreed: Boolean;
}

function AgreementCheckbox(props: IProps) {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <FormControlLabel
      className={classes.formControlLabel}
      control={<Checkbox className={classes.checkbox} onChange={props.onChange} name="agreed" />}
      label={intl.formatMessage({ id: "AGREEMENT_TEXT" })}
    />
  );
}

export default AgreementCheckbox;
